import { match as Match } from "react-router-dom";
import { Card, CardBody, CardHeader } from '../../../_metronic/_partials/controls';
import { ProductCatalogWidget } from '../components/ProductCatalogWidget';

type Props = {
  cardProps?: any;
  match: Match<IRouteParams>;
}

interface IRouteParams {
  productType: string;
}

const ProductCatalogByGroupPage = ({ cardProps, match }: Props) => {
  return (
    <Card {...cardProps}>
      <CardHeader
        className='border-0'
        title={`Product Catalog - ${match.params.productType}`}
        {...cardProps}
      />
      <CardBody {...cardProps}>
        <ProductCatalogWidget productType={match.params.productType} />
      </CardBody>
    </Card>
  );
};

export { ProductCatalogByGroupPage };
